import { Navigate } from "react-router";
import { useGetContractorUserQuery } from "../../../apis/ContractorUser.api";
import { PrimaryContractorUser, ContractorUser } from "../../../types/models/ContractorUser";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ContractorUserScoped = () => {
    const {
        data,
    } = useGetContractorUserQuery(PrimaryContractorUser.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/contractor-users/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ContractorUserScoped;
